import { z } from "zod";

import { EquipmentSchema, MovementSchema, PositionSchema } from "api/services/content/schemas/shared";
import { TypeOptionSchema } from "routes/patients/PatientProfile/components/UserCourse/components/LibraryHeader";
import { SortOptionSchema } from "utils/array/sort";

export const libraryListSettingsSchema = z.object({
  sort: SortOptionSchema,
  limit: z.number(),
  page: z.number(),
  filter: z.object({
    equipment: z.array(EquipmentSchema),
    movement: z.array(MovementSchema),
    position: z.array(PositionSchema),
    preview_joint: z.string(),
    search_term: z.string(),
    type: TypeOptionSchema,
  }),
});

export type LibraryListSettings = z.infer<typeof libraryListSettingsSchema>;
